/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { IDocumentPrinterInfo, IDocumentStoreService } from './IDocumentStoreService';
import { Nullable } from '@/Types';

class WebDocumentStoreService implements IDocumentStoreService {
  upToDateByPrinters(_: string[]): void {}

  upToDateByDocuments(_: string[]): void {}

  addOrUpdate(_: IDocumentPrinterInfo): void {}

  removeByDocumentGuid(_: string): void {}

  getByDocumentGuid(_: string): Nullable<IDocumentPrinterInfo> {
    return null;
  }
}

export const documentStoreService = new WebDocumentStoreService();
